<script>
  import relatorioServico from '../relatorio.servico';
  import projetoServico from '~modulos/projeto/servico';

  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import 'vue-strap/dist/vue-strap-lang';

  import { radio, datepicker } from 'vue-strap';
  import CabecalhoRelatorio from '~componentes/CabecalhoRelatorio.vue';
  import TelaCheia from '~componentes/TelaCheia.vue';
  
  export default {
    components: { datepicker, radio, CabecalhoRelatorio, TelaCheia },
    data() {
      return {
        filtros: {
          idProjeto: '',
          dataInicio: moment(new Date()).format('DD/MM/YYYY'),
          dataFim: moment(new Date()).format('DD/MM/YYYY'),
          situacao: 0,
          tipoData: 1,
        },
        projetos: [],
        relatorio: [],
        projeto: null,
        dataInicio: null,
        dataFim: null,
        configuracao: this.$storage.configuracao(),
        valorProvisaoPagar: 0,
        valorProvisaoReceber:0,
      }
    },
    methods: {
      listaDeProjetos() {
        return projetoServico
          .listaDeProjetosPermissao("RelProvisao")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      gerar() {
        this.relatorio = [];
        this.setarProjeto();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;

        this.valorProvisaoPagar = 0;
        this.valorProvisaoReceber = 0;
        
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");
            
            $('#gerar').button('loading');
            
            return relatorioServico.taxasProjeto(this.filtros);
          })
          .then(resultado => {
            this.relatorio = resultado.lancamentos;
            this.valorProvisaoPagar = resultado.provisaoDebitoAberto;
            this.valorProvisaoReceber = resultado.provisaoCreditoAberto;
            
            $('#gerar').button('reset');
            
            if (this.relatorio.length === 0) {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              this.$nextTick(() => {
                $('html, body').animate({
                  scrollTop: $('#relatorio').offset().top
                }, 800);
              });
            }
          })
          .catch(erro => {
            $('#gerar').button('reset');

            if (erro.status === 422) {
              this.$mensagemErro(erro, erro.body.message);
            } else {
              this.$mensagemErro(erro, 'Erro ao gerar relatório.');
            }
          });
      },
      gerarExcel() {
        this.relatorio = [];
        this.setarProjeto();
        this.dataInicio = this.filtros.dataInicio;
        this.dataFim = this.filtros.dataFim;

        this.valorProvisaoPagar = 0;
        this.valorProvisaoReceber = 0;

        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) throw new Error("validacao");

            $('#gerar-excel').button('loading');

            return relatorioServico.taxasProjetoExcel(this.filtros)
          })
          .then(arquivo => {
            $('#gerar-excel').button('reset');

            if (arquivo === '') {
              this.$swal('', 'Nenhum resultado encontrado.', 'info');
            } else {
              arquivo.download();
            }
          })
          .catch(erro => {
            $('#gerar-excel').button('reset');

            this.$mensagemErro(erro, 'Erro ao gerar relatório.');
          });
      },
      setarProjeto() {
        const idProjeto = this.filtros.idProjeto;

        this.projeto = idProjeto ? this.projetos.find(p => p.idProjeto == idProjeto) : null; 
      },
      historicoProvisao(p) {
        let historico = ''; 

        if (p.observacaoProvisao)
          historico = p.historico + ' - ' + p.observacaoProvisao
        else
          historico = p.historico;

        return historico;
      },
      retornaDataBaxa(p) {
        if (!p.baixa)
          return '---'

        return this.$options.filters.formatarData(p.dataBaixa)
      },
      corTipoProvisao(p) {
        if (p == 1)
          return "color:red"
        else
          return "color:blue";
      },
      retornaValor(p) {
        let valor = 0.0;

        if (p.tipoProvisao == 1) {
          valor -= p.valorProvisionado;
        } else {
          valor += p.valorProvisionado;
        }

        return valor;
      },
    },
    computed: {
      projetoSelecionado() {
        const idProjeto = this.filtros.idProjeto;
        
        return idProjeto ? this.projetos.find(projeto => projeto.idProjeto == idProjeto) : {};
      },
    },
    mounted() {
      this.$root.tituloDaPagina = `Relatório de Taxas Projeto`;
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';

      this.$root.botaoRetrocederMostrar = false;
      this.$root.botaoRetrocederRota = '';

      this.$events.on('botaoAcao', function() {
        window.print();
      });

      this.listaDeProjetos();
      
      const _this = this;

      $('#projeto').select2({
        theme: "bootstrap",
        placeholder: "Selecione...",
        language: "pt-BR"
      })
      .change(function(e) {
        _this.$set(_this.filtros, 'idProjeto', this.value);
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<style scoped>
  .provisaoBaixada {
    font-size: 1.40em;
    color: #7ec874;
  }
</style>

<template>
  <div :class="['wrapper wrapper-content animated', $root.animacaoPadrao]">
    <form class="hidden-print" @submit.prevent="gerar">

      <div class="ibox float-e-margins">
        <div class="ibox-content">

          <div class="row">
            <div class="col-xs-2">
              <div class="form-group">
                <radio v-model="filtros.tipoData"
                       :selected-value="0"
                       type="success">
                  Período Provisão
                </radio>
              </div>
            </div>

            <div class="col-xs-2">
              <div class="form-group">
                <radio v-model="filtros.tipoData"
                       :selected-value="1"
                       type="success">
                  Período Baixa
                </radio>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-6">
              <div class="form-group required" :class="{'has-error': errors.has('dataInicio')}">
                <label class="control-label" for="dataInicio"></label>

                <datepicker id="dataInicio"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataInicio"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>

                <p class="text-danger" v-show="errors.has('dataInicio')">{{ errors.first('dataInicio') }}</p>
              </div>
            </div>

            <div class="col-sm-6">
              <div class="form-group" :class="{'has-error': errors.has('dataFim')}">
                <label class="control-label">&nbsp; &nbsp;</label>

                <datepicker id="dataFim"
                            v-mascara="'data-mask'"
                            v-model="filtros.dataFim"
                            format="dd/MM/yyyy"
                            placeholder="  /  /     "
                            lang="pt-BR">
                </datepicker>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-xs-12">
              <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
                <label class="control-label" for="projeto">Projeto</label>

                <select id="projeto"
                        class="form-control"
                        v-model="filtros.idProjeto"
                        data-vv-name="projeto"
                        v-validate="'required'">
                  <option value="">Selecione...</option>
                  <option :value="projeto.idProjeto" v-for="(projeto, index) in projetos">{{ projeto.nomeProjeto }}</option>
                </select>

                <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
              </div>
            </div>
          </div>

          <div class="row" v-if="filtros.tipoData == 0">
            <div class="col-xs-1">
              <div class="form-group">
                <radio v-model="filtros.situacao"
                       :selected-value="0"
                       type="success">
                  Todas
                </radio>
              </div>
            </div>

            <div class="col-xs-1">
              <div class="form-group">
                <radio v-model="filtros.situacao"
                       :selected-value="1"
                       type="success">
                  Baixadas
                </radio>
              </div>
            </div>

            <div class="col-xs-1">
              <div class="form-group">
                <radio v-model="filtros.situacao"
                       :selected-value="2"
                       type="success">
                  Não baixadas
                </radio>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <button id="gerar"
                    type="button"
                    class="btn btn-primary"
                    @click="gerar"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-line-chart"></i>
              Gerar relatório
            </button>

            <button id="gerar-excel"
                    type="button"
                    class="btn btn-primary"
                    @click="gerarExcel"
                    data-loading-text="<i class='fa fa-spinner fa-pulse'></i> Gerando relatório...">
              <i class="fa fa-table"></i>
              Gerar relatório em excel
            </button>

            <tela-cheia texto="Visualizar em tela cheia"
                        icone="arrows-alt"
                        v-if="relatorio.length > 0">
            </tela-cheia>
          </div>
        </div>
      </div>
    </form>

    <cabecalho-relatorio :titulo="`Relatório de Provisões`" borda=""></cabecalho-relatorio>

    <div class="row" v-if="relatorio.length > 0" id="relatorio">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            
            <div class="table-responsive">
              <table class="table relatorio table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Projeto</th>
                    <th class="text-right">Período</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ projeto.nomeProjeto }}</td>
                    <td class="text-right">{{ dataInicio }} - {{ dataFim }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table relatorio table-bordered">
                <thead>
                  <tr>
                    <th></th>
                    <th>Data provisão</th>
                    <th>Data baixa</th>
                    <th>Histórico</th>
                    <th>Unidade</th>
                    <th>Departamento</th>
                    <th class="text-center">P/R</th>
                    <th v-if="projetoSelecionado.utilizarMetaEtapaProjeto">Meta Etapa</th>
                    <th>Rubrica</th>
                    <th>Subrubrica</th>
                    <th class="text-right">Valor (R$)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(provisao, indice) in relatorio">
                    <td class="text-center">
                      <div v-if="provisao.baixa">
                        <i class="fa fa-check provisaoBaixada" v-tooltip="'Baixada'"></i>
                      </div>
                    </td>
                    <td>{{ provisao.data | formatarData }}</td>
                    <td>{{ retornaDataBaxa(provisao) }}</td>
                    <td>{{ historicoProvisao(provisao) }} </td>
                    <td>{{ provisao.unidade | '---' }}</td>
                    <td>{{ provisao.departamento | '---' }}</td>
                    <td class="text-center" :style="corTipoProvisao(provisao.tipoProvisao)">{{ (provisao.tipoProvisao == 1) ? 'P' : 'R' }}</td>
                    <td v-if="projetoSelecionado.utilizarMetaEtapaProjeto">{{ provisao.nomeMeta }} - {{ provisao.nomeEtapa }}</td>
                    <td>{{ provisao.nomeRubrica }}</td>
                    <td>{{ provisao.nomeSubRubrica }}</td>
                    <td class="text-right">{{ retornaValor(provisao) | formatarNumero }}</td>
                  </tr>
                </tbody>
              </table>

              <table class="table relatorio table-condensed no-margins">
                <thead>
                  <tr>
                    <th>Total pendente a receber: {{ this.valorProvisaoReceber | formatarNumero }}</th>
                    <th>Total pendente a pagar: {{ this.valorProvisaoPagar | formatarNumero }}</th>
                    <th>Diferença: {{ (this.valorProvisaoReceber + this.valorProvisaoPagar) | formatarNumero }}</th>
                  </tr>
                </thead>
              </table>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/relatorio/componentes/RelatTaxasProjeto.vue